import { useTranslation } from "react-i18next";
import { useRemoteMutation } from "../useRemote/useRemoteMutation";
import { RemoteApiError } from "../useRemote/types";
import { BookableEquipmentAssignmentDto } from "../../../components/FacilityManager/Domain/Types/FloorPlan/BookableEquipmentAssignment.type";

export function useRemoteAssignBookableEquipment() {
  const { t } = useTranslation();
  return useRemoteMutation<void, RemoteApiError, BookableEquipmentAssignmentDto>({
    key: ["assign-bookable-equipment"],
    url: "/bookable-equipment",
    method: "put",
    snackbarTextOnFail: t("There was a server error")
  });
}
